import React from 'react'
import './Tablet.css'

export default function Tablet() {
  return (
    <div className="tablet border" >
        <div className="tabtop">
        <hr className="hr"></hr>
        </div>
        <div className="tabmid">
            <img src="./img/tab.png" className="tabmid" alt="tab"/>

        </div>
        <div className="tabbottom" >
        </div>
    </div>
  )
}
